import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { AppConfigService } from 'src/app/theme/utils/app-config-service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { MatSidenav } from '@angular/material/sidenav';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HudsonHeaderComponent } from '../hudson/header/header.component';
import { HudsonFooterComponent } from '../hudson/footer/footer.component';
import { OlivorHeaderComponent } from '../olivor/header/header.component';
import { OlivorFooterComponent } from '../olivor/footer/footer.component';
import { GrisonHeaderComponent } from '../grison-dairy/header/header.component';
import { GrisonFooterComponent } from '../grison-dairy/footer/footer.component';
import { LittlefarmHeaderComponent } from '../little-farm/header/header.component';
import { LittlefarmFooterComponent } from '../little-farm/footer/footer.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { TrackingService } from 'src/app/shared/services/tracking.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-global',
  templateUrl: './global.component.html',
  styleUrls: ['./global.component.scss']
})
export class GlobalComponent implements OnInit {

  dynamicHeaderComponent: any;
  dynamicFooterComponent: any;
  themeType: any;
  isCmsView: boolean = false;
  cartData = { items: 0, total: 0.00 };
  storeDetails = {};
  loggedIn: boolean;
  featureTags = {};
  cmsUrls: string[] = [
    '/', '/about-us', '/our-services', '/faq', '/themarket', 
    '/terms-and-conditions', '/privacy-policy', '/refund-policy', 
    '/cancellation-policy', '/the-farm-store', '/about', 
    '/home-delivery-and-pick-up-information', '/csa-box-information'
  ];
  isorderSummery:boolean = true;
  private destroy$ = new Subject<void>();
  constructor(
    private appConfigService: AppConfigService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    public sharedDataService: SharedDataService,
    public notification: NotificationService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private trackingService: TrackingService,
  ) {}

  ngOnInit() {
    this.initializeRouting();
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    this.appConfigService.loadAppConfig().then(async (data: any) => {
      this.themeType = data.themeType;
      this.loadDynamicComponents(this.themeType);
      this.storeDetails = this.activatedRoute.snapshot.data['store']['response']['data']['store'];
      this.loggedIn = this.apiService.loggedIn();
      this.apiService.isLoggedIn
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.loggedIn = data.loggedIn;
      });

      this.sharedDataService.cartDataSource
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.cartData = data || { items: 0, total: 0.00 };
      });
    });
    if(this.featureTags && !this.featureTags['sf_hide_ordersummary']){
      this.sharedDataService.cartDataSource
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.isorderSummery = data
      });
    }
    
    if (isPlatformBrowser(this.platformId)) {
      this.trackingService.initializeTracking();
      this.trackingService.setTrackingMetadata() 
    }
  }
  
  toggleDrawer() {
    this.sharedDataService.toggleDrawer(true); // Open the drawer
  }

  initializeRouting() {
    let currentUrl = this.router.url; // Get current URL
    this.isCmsView = this.cmsUrls.includes(currentUrl);
    const orderUrls = ['/edit-order', '/account/orders'];
    if(this.featureTags && this.featureTags['sf_hide_ordersummary']){
      this.isorderSummery = !orderUrls.includes(currentUrl);
    }
    
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: NavigationEnd) => {
        const url = event.url;        
        if(this.featureTags && this.featureTags['sf_hide_ordersummary']){
          this.isorderSummery = !orderUrls.includes(url);
          currentUrl = '';
        }
        if (this.themeType === 'Olivor') {
          this.isCmsView = this.cmsUrls.includes(url);
        } else {
          this.isCmsView = url === '/';
        }
      });

    this.sharedDataService.isCmsView
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      if(!!data){
        this.isCmsView = data;
      }
    });    
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadDynamicComponents(themeType: string) {
    let headerComponent, footerComponent;
  
    switch (themeType) {
      case 'Hudson':
        headerComponent = HudsonHeaderComponent;
        footerComponent = HudsonFooterComponent;
        break;
      case 'Olivor':
        headerComponent = OlivorHeaderComponent;
        footerComponent = OlivorFooterComponent;
        break;
      case 'grison-dairy':
      case 'woodview':
        headerComponent = GrisonHeaderComponent;
        footerComponent = GrisonFooterComponent;
        break;
      case 'little-farm':
        headerComponent = LittlefarmHeaderComponent;
        footerComponent = LittlefarmFooterComponent;
        break;
      default:
        headerComponent = HeaderComponent;
        footerComponent = FooterComponent;
    }
  
    this.dynamicHeaderComponent = headerComponent;
    this.dynamicFooterComponent = footerComponent;
  }
}
